import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Horse_show } from '../../models/horse_show';
import { Horse_show_entry_with_types } from '../../models/horse_show_entry_with_types';
import { Entry_type } from '../../models/entry_type';
import { Signature } from '../../models/signature';
import { Person } from '../../models/person';
import { ModalEditPersonComponent } from '../people/modal-edit-person/modal-edit-person.component';
import { ModalChoosePersonComponent } from '../people/modal-choose-person/modal-choose-person.component';
import { ModalAddPersonComponent } from '../people/modal-add-person/modal-add-person.component';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { UsefPersonService } from '../../providers/usef-person.service';
import { PersonService } from '../../providers/person.service';
import { CopyEntryForCircuitService } from '../../providers/copy-entry-for-circuit.service';
import { WaiverService } from '../../providers/waiver.service';
import { faUser, faSpinner, faTrash } from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-modal-copy-circuit-entry',
  templateUrl: './modal-copy-circuit-entry.component.html',
styleUrls:  ['./modal-copy-circuit-entry.component.css']
})
export class ModalCopyCircuitEntryComponent extends SmsAbstractAppPage implements OnInit {

  faUser = faUser;
  faSpinner = faSpinner;
  faTrash = faTrash;

  horse_show_list: Horse_show[] = [];
  horse_show_entry: Horse_show_entry_with_types = new Horse_show_entry_with_types({});
  entry_type: Entry_type = new Entry_type({});
  waiver_text: string = "";

//Owner Signature
  owner_signature: Signature = this.getBlankSignature("OWNER", "OWNER");

  //Rider signatures
  rider_signature_list: Signature[] = [];

  trainer_signature: Signature = this.getBlankSignature("TRAINER", "TRAINER");

  parent_signature_list: Signature[] = [];

  parent_list: Person[] = [];

  minor_detected: boolean = false;
  minor_lookup_in_progress: boolean = false;

  operation_pending: boolean = false;

  copy_completed$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal,
    private copyEntryForCircuitService:CopyEntryForCircuitService,
    private personService: PersonService,
    private usefPersonService: UsefPersonService,
    private waiverService: WaiverService,
    private modal: NgbModal) {
    super();
  }

  ngOnInit(): void {
  }

  public setParameters(horse_show_list:Horse_show[], entry_id: string){
    this.horse_show_list = horse_show_list;
    this.copyEntryForCircuitService.getEntryToCopy(entry_id).then(horse_show_entry => {
      this.horse_show_entry = horse_show_entry;
      this.entry_type = horse_show_entry.entry_type_objects[0];
      this.seedRiderSignatures(horse_show_entry.rider_list);
      this.repopulateExistingSignatures();
      this.checkRidersForMinors(horse_show_entry.rider_list);
      this.waiverService.get(horse_show_list[0].waiver_id).then(waiver => {
          this.waiver_text = waiver.waiver_text.replace(/\\/g, "");
        }).catch(error => {
          this.handleError(error);
        });
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleCopy(){

    //Check signatures
    let errors:string[] = [];
    if((this.owner_signature == undefined || this.owner_signature.signature == '' || this.owner_signature.accepted_terms == false || this.owner_signature.read_document == false) && (!this.owner_signature.request_signature || this.owner_signature.request_signature_email == '')){
      errors.push("The entry must be signed for the owner and the signer must indicate that they have read and accepted the terms of entering this horse show.");

    }
    if((this.trainer_signature == undefined || this.trainer_signature.signature == '' || this.trainer_signature.accepted_terms == false || this.trainer_signature.read_document == false) && (!this.trainer_signature.request_signature || this.trainer_signature.request_signature_email == '')){
      errors.push("The entry must be signed for the trainer and the signer must indicate that they have read and accepted the terms of entering this horse show.");

    }
    if(this.rider_signature_list == undefined || this.rider_signature_list.length < this.horse_show_entry.rider_list.length) {
     errors.push("All riders on this entry must sign and the signer must indicate that they have read and accepted the terms of entering this horse show.");
    }
    this.rider_signature_list.forEach((signature, i) => {
      if((signature.signature == '' || signature.accepted_terms == false || signature.read_document == false)  && (!signature.request_signature || signature.request_signature_email == '')){
        errors.push("The entry must be signed for each rider and the signer must indicate that they have read and accepted the terms of entering this horse show.");
      }
    });

    if (this.minor_detected && this.parent_signature_list.length === 0) {
      errors.push("A minor rider has been detected on this entry. A parent or guardian signature is required before copying.");
    }
    let parent_unsigned = false;
    this.parent_signature_list.forEach(sig => {
      if (sig.signature == '' || sig.accepted_terms == false || sig.read_document == false) {
        parent_unsigned = true;
      }
    });
    if (parent_unsigned) {
      errors.push("All parent or guardian signatures must be completed before copying.");
    }

  if(errors.length > 0){
    this.handleError(errors.join("\n"));
    return;
  }

    this.operation_pending = true;

    //Prune existing signatures from this page and re-add to entry
    if(this.horse_show_entry.signature_list && this.horse_show_entry.signature_list.length > 0){
      this.horse_show_entry.signature_list.forEach((signature, i) => {
        //Leave only payee which is added to list through a separate process
        if(signature.role != 'PAYEE'){
          this.horse_show_entry.signature_list.splice(i, 1);
        }
      });
    } else {
      this.horse_show_entry.signature_list = [];
    }

    //Re-add from this form
    this.owner_signature.user_person_id = this.horse_show_entry.owner.id;
    this.horse_show_entry.signature_list.push(this.owner_signature);
    this.trainer_signature.user_person_id = this.horse_show_entry.trainer.id;
    this.horse_show_entry.signature_list.push(this.trainer_signature);

    this.rider_signature_list.forEach((rider_sig, i) => {

      let rider = this.horse_show_entry.rider_list[i];
      if(rider != undefined){
        rider_sig.user_person_id = rider.id;
      }

    });

    this.horse_show_entry.signature_list = this.horse_show_entry.signature_list.concat(this.rider_signature_list).concat(this.parent_signature_list);

      //Call teh copy circuit service
      //post the horse show entry, signatures, and horse show list to a controller on the API
      //Iterate the horse shows using the entry as the template
      //Create the pending entry, pending competitions, billing items and the signatures
      //return promise resolve true
      //Navigate to entries to reload and display the copied entry - good ta go

      //Inside promise
      //NAVIGATE TO 'SHOPPING CART'

      this.copyEntryForCircuitService.copyForCircuit(this.horse_show_list, this.horse_show_entry).then(response => {

        if(response){

          this.copy_completed$.emit(true);

        } else {
          this.handleError(response);
        }

      }).catch(error => {
        this.handleError(error);
      });



  }


  private getBlankSignature(party_type: string, role: string, user_person_id: string = '') {
      return new Signature({
         document_type: "HORSE SHOW ENTRY",
         document_id: this.horse_show_entry.id,
         read_document: false,
         signature: '',
         user_person_id: user_person_id,
         role: role,
         party_to_entry: party_type,
         accepted_terms: false,
         responsible_party: false,
            contact_consent: false
          });
    }

  handleEditPerson(person: Person){
    let modal_ref_person = this.modal.open(ModalEditPersonComponent, { size: 'lg'});

    modal_ref_person.componentInstance.warning_language = "You are about to make changes for the existing record for " + person.first_name + " " + person.last_name + ". If your intention is to create a different person for a part of this entry close this dialog and return to \"Add Horse and People\".";

    modal_ref_person.componentInstance.person = person;

    if(person.use_usef_personal_details && person.usef_person_uuid){
      this.usefPersonService.getByUuid(person.usef_person_uuid).then(usef_person =>{
        modal_ref_person.componentInstance.usef_person = usef_person;
      }).catch(error =>{
        this.handleError(error);
      });
    }

    modal_ref_person.componentInstance.person_saved$.subscribe((updated_person: Person)=>{
      this.personService.update(updated_person).then(updated_person => {
        modal_ref_person.close();
        person = updated_person;
      }).catch(error =>{
        this.handleError(error);
      });
    }, error =>{
      this.handleError(error);
    });


  }

    private seedRiderSignatures(riders: Person[]){
    riders.forEach(rider => {
      const existing = this.horse_show_entry.signature_list?.find(sig =>
        sig.user_person_id == rider.id && sig.party_to_entry == 'RIDER'
      );
      if (existing) {
        this.rider_signature_list.push(existing);
      } else {
        this.rider_signature_list.push(this.getBlankSignature("RIDER", "RIDER", rider.id));
      }
    });
  }

  private repopulateExistingSignatures(){
    if (!this.horse_show_entry.signature_list) return;
    const parent_signatures: Signature[] = [];
    this.horse_show_entry.signature_list.forEach((signature: Signature) => {
      if(signature.party_to_entry == 'OWNER'){
        this.owner_signature = signature;
      }
      if(signature.party_to_entry == 'TRAINER'){
        this.trainer_signature = signature;
      }
      if(signature.party_to_entry == 'PARENT'){
        parent_signatures.push(signature);
      }
    });
    if (parent_signatures.length === 0) return;
    Promise.all(parent_signatures.map(sig => this.personService.get(sig.user_person_id))).then(parents => {
      this.parent_signature_list.push(...parent_signatures);
      this.parent_list.push(...parents);
    }).catch(error => {
      this.handleError(error);
    });
  }

  private checkRidersForMinors(riders: Person[]) {
    this.minor_detected = false;

    const usef_riders: Person[] = [];
    riders.forEach(rider => {
      if (rider.usef_person_uuid || rider.usef_number) {
        usef_riders.push(rider);
      } else if (this.isUnder18FromBirthDate(rider.birth_date)) {
        this.minor_detected = true;
      }
    });

    if (usef_riders.length === 0) return;

    this.minor_lookup_in_progress = true;
    const lookups = usef_riders.map(rider => {
      const lookup = rider.usef_person_uuid
        ? this.usefPersonService.getByUuid(rider.usef_person_uuid)
        : this.usefPersonService.getByUsefId(rider.usef_number, 'I');
      return lookup.then(usef_person => {
        if (usef_person.is_minor) {
          this.minor_detected = true;
        }
      }).catch(() => {
        if (this.isUnder18FromBirthDate(rider.birth_date)) {
          this.minor_detected = true;
        }
      });
    });

    Promise.all(lookups).then(() => {
      this.minor_lookup_in_progress = false;
    });
  }

  private isUnder18FromBirthDate(birth_date: string): boolean {
    if (!birth_date) return false;
    const dob = new Date(birth_date);
    if (isNaN(dob.getTime())) return false;
    const today = new Date();
    const eighteenth_birthday = new Date(dob.getFullYear() + 18, dob.getMonth(), dob.getDate());
    return today < eighteenth_birthday;
  }

  handleDeleteParent(i: number) {
    this.parent_list.splice(i, 1);
    this.parent_signature_list.splice(i, 1);
  }

  handleAddParent(){
    let modal_ref_person = this.modal.open(ModalAddPersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person = new Person({});

      modal_ref_person.componentInstance.person_saved$.subscribe((new_person: Person) => {
       modal_ref_person.close();
         this.personService.create(new_person).then(parent => {
           this.parent_list.push(parent);
           let signature: Signature = this.getBlankSignature('PARENT', 'PARENT');
           signature.user_person_id = parent.id;
           this.parent_signature_list.push(signature);
         }, error =>{
           this.handleError(error);
         });

       });
  }

   handleChooseParent(){
    let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.role = 'PARENT';

      modal_ref_person.componentInstance.add_new_selected$.subscribe(event =>{
        modal_ref_person.close();
        this.handleAddParent();
      }, error => {
        this.handleError(error);
      });

      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
       modal_ref_person.close();
         this.parent_list.push(selected_person);
         let signature: Signature = this.getBlankSignature('PARENT', 'PARENT');
         signature.user_person_id = selected_person.id;
         this.parent_signature_list.push(signature);
       });

  }

}
